/* ==========================================================================
   CookiesBannerManager class
   ========================================================================== */

import DialogManager from '../elements/DialogManager'
import { type CookieOptions, setCookie, cookieExists } from '../utils/cookies'

export default class CookiesBannerManager extends DialogManager {
  expirationDays: number
  path: string

  constructor (options: CookieOptions = {}) {
    super()
    const { expirationDays, path } = options
    this.expirationDays = expirationDays ?? 14
    this.path = path ?? '/'
    this.dialogSelector = '[data-ui-el="nfb-cookies-banner"]'
  }

  show (): void {
    if (cookieExists('cookies_banner') !== undefined) {
      return
    }
    super.show()
  }

  close (): void {
    super.close()
    setCookie('cookies_banner', '1', { expirationDays: this.expirationDays, path: '/' })
  }
}
